<template>
  <section class="view-wrap">
    <div class="header-spacer"></div>
    <div class="container">
      <div class="row row-wrap">
        <!-- {{ displayNodes }} -->
        <div class="column column-100">
          <h1>{{ info.title }}</h1>
        </div>
        <div class="column column-66" v-if="info.content">
          <div v-if="info.hero_image_top">
            <transition name="fade">
              <img :src="info.hero_image_top.url" @load="imageLoaded=true" v-show="imageLoaded" />
            </transition>
          </div>

          <!-- STREAMFIELD -->
          <div v-for="block in info.content" v-bind:key="block.id">
            <div v-if="block.type==='paragraph'" v-html="block.value"></div>
            <div v-else-if="block.type==='info_block'">
              <NodeInfo :nodeData="block.value" :pageNodes="info.node" />
            </div>
          </div>
          <!-- END STREAMFIELD -->
          <hr />
          <div v-for="node in displayNodes" v-bind:key="node.node">
            <div v-if="node.node==='Lodging Amenities'">
              <ul v-if="node.node==='Lodging Amenities'">
                <li v-for="item in node.child_nodes" v-bind:key="item">{{ item }}</li>
              </ul>
              <!-- {{ node.node }}: {{ node.child_nodes.join(' | ') }} -->
            </div>
          </div>
          <span v-if="info.meta.type==='pages.EventPage'">{{ info.event_date_display }}</span>
        </div>
        <div class="column column-33 right-side" v-if="info.address || backPageID">
          <div v-if="backPageID" class="close-window" @click="$router.push({ name: backPageID})">
            <h4>Close</h4>
            <i class="far fa-window-close fa-2x for-slide"></i>
          </div>
          <div v-if="info.address">
            <BasicMap :address="info.address" />
          </div>
          <div class="stats">
            <p v-if="info.address">{{ info.address }}</p>
            <p v-if="info.phone_number">Phone: {{ info.phone_number }}</p>
            <p v-if="info.starting_at">Starting at: {{ info.starting_at }}</p>
            <p v-if="info.website">
              <a :href="info.website">{{ info.website }}</a>
            </p>
          </div>
        </div>
        <!-- {{ info.parent_related_items }} -->
        <div class="column column-100">
          <span v-if="info.related_items&&info.parent_related_items">
            <!-- <span v-if="info.related_items.length > 0"> -->
            <span v-for="section in info.related_items" v-bind:key="section.value.id">
              <RelatedItems :relatedInfo="section.value" :pageNodes="info.node" />
            </span>
            <!-- </span> -->
            <!-- <span v-else> -->
            <span v-for="section in info.parent_related_items" v-bind:key="section.value.id">
              <RelatedItems :relatedInfo="section.value" :pageNodes="info.node" />
            </span>
            <!-- </span> -->
          </span>
        </div>

        <div class="column column-100"></div>
      </div>
    </div>
  </section>
</template>

<script>
// import TopMenu from '@/components/TopMenu.vue'
import axios from "axios";
import NodeInfo from "@/components/NodeInfo.vue";
import RelatedItems from "@/components/RelatedItems.vue";
import BasicMap from "@/components/BasicMap.vue";
export default {
  name: "page",
  data() {
    return {
      info: [],
      imageLoaded: false,
    };
  },
  components: {
    NodeInfo,
    RelatedItems,
    BasicMap,
  },
  props: {
    backPageID: null,
  },
  watch: {
    $route(to, from) {
      this.fetchData().then((data) => {
        this.info = data;
      });
    },
    // info: {
    //   handler(val) {
    //     let met = document.createElement('meta')
    //     met.setAttribute('property','og:title')
    //     met.content = this.info.title
    //     // document.head.childNodes.push(met);
    //     document.getElementsByTagName("head")[0].appendChild(met);
    //   },
    //   deep: true
    // }
  },
  computed: {
    contentWidth: function () {
      if (this.info.address) {
        return "column-50";
      }
      return "column-100";
    },
    displayNodes: function () {
      var nodes = this.info.node;
      // nodes = nodes.filter(n => { return n.path.length > 4 })
      var nodeSections = [];
      for (var node in nodes) {
        // Last and -> only include direct children of the node
        var tempChildNodes = nodes.filter((n) => {
          return (
            n.path.startsWith(nodes[node].path) &&
            n.path !== nodes[node].path &&
            n.path.length === nodes[node].path.length + 4
          );
        });
        var childNodes = [];
        for (var n in tempChildNodes) {
          childNodes.push(tempChildNodes[n].name);
        }
        nodeSections.push({ node: nodes[node].name, child_nodes: childNodes });
      }
      nodeSections = nodeSections.filter((n) => {
        return n.child_nodes.length > 0;
      });
      for (var node in nodeSections) {
        for (var chil in nodeSections[node].child_nodes) {
          for (var x in nodeSections) {
            if (nodeSections[node].child_nodes[chil] == nodeSections[x].node) {
              nodeSections[node].child_nodes.splice(chil, 1);
            }
          }
        }
      }
      nodeSections = nodeSections.filter((n) => {
        return n.child_nodes.length > 0;
      });
      return nodeSections;
    },
  },
  created() {
    this.fetchData().then((data) => {
      this.info = data;
      if (this.info.custom_styles) {
        let styles = document.createElement("style");
        styles.type = "text/css";
        styles.id = "temp-styles";
        for (let d in this.info.custom_styles) {
          if (!this.info.custom_styles[d].value.hide) {
            styles.appendChild(
              document.createTextNode(this.info.custom_styles[d].value.style)
            );
          }
        }
        document.getElementsByTagName("head")[0].appendChild(styles);
      }
    });
    if (this.backPageID) {
      document.body.classList.add("body-slide-open");
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.info.custom_styles) {
      let tempSty = document.getElementById("temp-styles");
      if (tempSty) {
        tempSty.remove();
      }
    }
    document.body.classList.remove("body-slide-open");
    next();
  },
  mounted() {
    //  console.log('MOUNTED PAGE')
  },
  updated() {
    // console.log('UPDATED PAGE')
    // console.log(this.info)
  },
  methods: {
    fetchData() {
      console.log("FETCH THE DATA");
      var id = this.$route.meta.id;
      return axios.get("/api/v2/pages/" + id).then((response) => {
        //  console.log(JSON.stringify(response))
        return response.data;
      });
    },
  },
};
</script>


<style scoped>
.slide-section h1 {
  font-size: 3.6rem;
}

.right-side {
  position: relative;
}

.close-window {
  /* cursor: pointer; */
  text-align: right;
  display: flex;
  align-items: center;
  position: absolute;
  top: -5.85rem;
  right: 1rem;
}

.close-window:hover {
  color: #ccc;
}

.close-window i {
  display: inline-block;
  cursor: pointer;
}

.close-window h4 {
  display: inline-block;
  cursor: pointer;
  margin-right: 1rem;
  margin-bottom: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */

.fade-enter-active {
  transition: all 1s ease;
}
.fade-leave-active {
  /* transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
  transition: all 1s ease;
}
.fade-enter, .fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
  /* transform: translateX(100%); */
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  /* transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
  transition: all 0.5s ease;
}
.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
  opacity: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-enter-active {
  transition: all 0.5s ease;
}
.slide-leave-active {
  /* transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
  transition: all 0.5s ease;
}
.slide-enter, .slide-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
  /* opacity: 0; */
}
</style>
